import { grey } from "@mui/material/colors";
import { lighten, PaletteOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    table: {
      head: {
        text: string;
        background: string;
      };

      orange: {
        main: string;
      };
    };
    yellow: {
      main: string;
    };

    orange: {
      main: string;
    };

    sidebar: {
      background: string;
      border: string;
      categorySelected: string;
      listSubheader: string;
      listItem: string;
      text: string;
      expandingSidebarCategorySelected?: string;
    };
  }

  // Allow configuration using `createTheme`
  interface PaletteOptions {
    table?: {
      head: {
        text: string;
        background: string;
      };
      orange: {
        main: string;
      };
    };
    yellow?: {
      main: string;
    };
    orange?: {
      main: string;
    };
    sidebar?: {
      background: string;
      border: string;
      categorySelected: string;
      listSubheader: string;
      listItem: string;
      text: string;
      expandingSidebarCategorySelected?: string;
    };
  }
}

export const palette: PaletteOptions & any = {
  primary: {
    main: "#005687",
    dark: "#1598CF",
    light: "#37B3E1",
    contrastText: "#FFFFFF",
  },

  //<--not in use yet
  secondary: {
    main: "#00AEEF",
    contrastText: "#FFFFFF",
  },
  //-->

  success: {
    main: "#2E7D32",
    dark: "#1B5E20",
    light: "#4CAF50",
    contrastText: "#FFFFFF",
  },
  info: {
    main: "#0288D1",
    dark: "#01579B",
    contrastText: "#FFFFFF",
    light: "#03A9F4",
  },
  warning: {
    main: "#ED6C02",
    dark: "#E65100",
    light: "#FF9800",
    contrastText: "#FFFFFF",
  },

  error: {
    main: "#D32F2F",
    dark: "#C62828",
    light: "#EF5350",
    contrastText: "#FFFFFF",
  },
  text: {
    primary: "#000000DE",
    secondary: "#00000099",
    disabled: "#00000061",
  },
  background: {
    //Page Background color
    default: "rgb(250, 250, 251)",
    //Paper background color
    paper: "#FFFFFF",
  },

  grey: {
    500: "#B0B0B0",
    600: "#f5f5f5",
    700: "#303030",
    800: "#424242",
  },
  divider: "#EAEDFB",

  // Custom attributes
  table: {
    head: {
      text: grey[900],
      background: grey[100],
    },
  },
  orange: {
    main: "#F57C00",
  },

  //Used for GCGRA Intake Form
  yellow: {
    main: "#C7AD6D",
  },

  sidebar: {
    background: "#303030",
    border: "#2E4E6E",
    categorySelected: "#424242",
    listItem: "#263238",
    listSubheader: "#263238",
    text: "#000000",
    expandingSidebarCategorySelected: lighten("#005687", 0.85),
  },
};
